import type { FunctionComponent } from 'react';

import { intl } from '@trello/i18n';
import { EnterpriseIcon } from '@trello/nachos/icons/enterprise';
import { OrganizationVisibleIcon } from '@trello/nachos/icons/organization-visible';
import { PrivateIcon } from '@trello/nachos/icons/private';
import { PublicIcon } from '@trello/nachos/icons/public';

import styles from './BoardVisibilityBadge.less';

interface BoardVisibilityBadgeProps {
  visibility: string;
  color?: string;
}

export const BoardVisibilityBadge: FunctionComponent<
  BoardVisibilityBadgeProps
> = ({ visibility, color }) => {
  switch (visibility) {
    case 'public':
      return (
        <div
          title={intl.formatMessage({
            id: 'board perms.public.short summary',
            defaultMessage:
              'Anyone on the internet can see this board. Only board members can edit.',
            description: 'Public visibility icon tooltip',
          })}
          className={styles.visibilityBadge}
        >
          <PublicIcon size="small" color={color} />
        </div>
      );
    case 'private':
      return (
        <div
          title={intl.formatMessage({
            id: 'board perms.private.short summary',
            defaultMessage: 'Only board members can see and edit this board.',
            description: 'Private visibility icon tooltip',
          })}
          className={styles.visibilityBadge}
        >
          <PrivateIcon size="small" color={color} />
        </div>
      );
    case 'enterprise':
      return (
        <div
          title={intl.formatMessage({
            id: 'board perms.enterprise.short summary',
            defaultMessage:
              'All members of the Workspace and organization can see this board.',
            description: 'Enterprise visibility icon icon tooltip',
          })}
          className={styles.visibilityBadge}
        >
          <EnterpriseIcon size="small" color={color} />
        </div>
      );
    case 'org':
    default:
      return (
        <div
          title={intl.formatMessage({
            id: 'board perms.org.short summary',
            defaultMessage:
              'All members of the Workspace can see and edit this board.',
            description: 'Organization visibility icon tooltip',
          })}
          className={styles.visibilityBadge}
        >
          <OrganizationVisibleIcon size="small" color={color} />
        </div>
      );
  }
};
